import { UserRights } from '@work4all/models/lib/additionalEnums/UserRights';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { ModuleAccessRightType } from '@work4all/models/lib/Enums/ModuleAccessRightType.enum';

import {
  PermissionRequiredRight,
  PermissionsRequiredRightsByEntity,
} from '../types';

// ==========================================
// Common Permission Configurations
// ==========================================

const COMMON_TIKCET_MAR_LIST: PermissionRequiredRight[] = [
  {
    type: 'ModuleAccessRight',
    value: ModuleAccessRightType.FEATURE_WORK_4_ALL_WEB_FULL,
  },
  {
    type: 'ModuleAccessRight',
    value: ModuleAccessRightType.FEATURE_TICKETS_LIGHT,
  },
];

// ==========================================
// CRM Permission Configurations
// ==========================================

export const CRM_PERMISSIONS_REQUIRED_RIGHTS: PermissionsRequiredRightsByEntity =
  {
    // Tasks
    [Entities.task]: {
      canAdd: [
        [
          {
            type: 'UserRight',
            value: UserRights.TelefonateAufgabenNotizenAnlegenAendern,
          },
          {
            type: 'UserRight',
            value: UserRights.TelefonateAufgabenNotizenAendernLoeschenEigene,
          },
        ],
      ],
      canEdit: [
        {
          type: 'UserRightOperation',
          value: UserRights.TelefonateAufgabenNotizenAnlegenAendern,
          ownlyOwnPermissionCode:
            UserRights.TelefonateAufgabenNotizenAendernLoeschenEigene,
          ownageProperty: ['userId', 'user.id'],
        },
      ],
      canDelete: [
        {
          type: 'UserRightOperation',
          value: UserRights.TelefonateAufgabenNotizenLoeschen,
          ownlyOwnPermissionCode:
            UserRights.TelefonateAufgabenNotizenAendernLoeschenEigene,
          ownageProperty: ['userId', 'user.id'],
        },
      ],
    },

    // Call Memos
    [Entities.callMemo]: {
      canAdd: [
        [
          {
            type: 'UserRight',
            value: UserRights.TelefonateAufgabenNotizenAnlegenAendern,
          },
          {
            type: 'UserRight',
            value: UserRights.TelefonateAufgabenNotizenAendernLoeschenEigene,
          },
        ],
      ],
      canEdit: [
        {
          type: 'UserRightOperation',
          value: UserRights.TelefonateAufgabenNotizenAnlegenAendern,
          ownlyOwnPermissionCode:
            UserRights.TelefonateAufgabenNotizenAendernLoeschenEigene,
          ownageProperty: ['userId', 'user.id'],
        },
      ],
      canDelete: [
        {
          type: 'UserRightOperation',
          value: UserRights.TelefonateAufgabenNotizenLoeschen,
          ownlyOwnPermissionCode:
            UserRights.TelefonateAufgabenNotizenAendernLoeschenEigene,
          ownageProperty: ['userId', 'user.id'],
        },
      ],
    },

    // Tickets
    [Entities.ticket]: {
      canAdd: [
        { type: 'UserRight', value: UserRights.TicketAnlegenAendern },
        COMMON_TIKCET_MAR_LIST,
      ],
      canEdit: [
        { type: 'UserRightOperation', value: UserRights.TicketAnlegenAendern },
        COMMON_TIKCET_MAR_LIST,
      ],
      canDelete: [
        { type: 'UserRightOperation', value: UserRights.TicketLoeschen },
        COMMON_TIKCET_MAR_LIST,
      ],
    },

    // Sales Opportunities
    [Entities.salesOpportunities]: {
      canAdd: [
        [
          { type: 'UserRight', value: UserRights.VerkaufschancenNutzen },
          {
            type: 'UserRight',
            value: UserRights.VerkaufschancenNurEigeneAendernLoeschen,
          },
        ],
      ],
      canEdit: [
        {
          type: 'UserRightOperation',
          value: UserRights.VerkaufschancenNutzen,
          ownlyOwnPermissionCode:
            UserRights.VerkaufschancenNurEigeneAendernLoeschen,
          ownageProperty: ['creator.id'],
        },
      ],
      canDelete: [
        {
          type: 'UserRightOperation',
          value: UserRights.VerkaufschancenNutzen,
          ownlyOwnPermissionCode:
            UserRights.VerkaufschancenNurEigeneAendernLoeschen,
          ownageProperty: ['creator.id'],
        },
      ],
    },

    // Appointments
    [Entities.appointment]: {
      canAdd: [
        [
          { type: 'UserRight', value: UserRights.TermineAnlegenAendern },
          { type: 'UserRight', value: UserRights.TermineAendernLoeschenEigene },
        ],
      ],
      canEdit: [
        {
          type: 'UserRightOperation',
          value: UserRights.TermineAnlegenAendern,
          ownlyOwnPermissionCode: UserRights.TermineAendernLoeschenEigene,
          ownageProperty: ['userId', 'user.id'],
        },
      ],
      canDelete: [
        {
          type: 'UserRightOperation',
          value: UserRights.TermineLoeschen,
          ownlyOwnPermissionCode: UserRights.TermineAendernLoeschenEigene,
          ownageProperty: ['userId', 'user.id'],
        },
      ],
    },

    // Notes
    [Entities.note]: {
      canAdd: [
        [
          {
            type: 'UserRight',
            value: UserRights.TelefonateAufgabenNotizenAnlegenAendern,
          },
          {
            type: 'UserRight',
            value: UserRights.TelefonateAufgabenNotizenAendernLoeschenEigene,
          },
        ],
      ],
      canEdit: [
        {
          type: 'UserRightOperation',
          value: UserRights.TelefonateAufgabenNotizenAnlegenAendern,
          ownlyOwnPermissionCode:
            UserRights.TelefonateAufgabenNotizenAendernLoeschenEigene,
          ownageProperty: ['userId', 'user.id'],
        },
      ],
      canDelete: [
        {
          type: 'UserRightOperation',
          value: UserRights.TelefonateAufgabenNotizenLoeschen,
          ownlyOwnPermissionCode:
            UserRights.TelefonateAufgabenNotizenAendernLoeschenEigene,
          ownageProperty: ['userId', 'user.id'],
        },
      ],
    },
  };
